import http from '@/common/http.js'
import resource from '@/model/resource.js'

function info(params, callback) {
	http.request({
		url		: 'project/info?id='+params.id,
		success: (res) => {
			callback && callback(res);
		}
	})
	
	// http.jsonp({
	// 	url		: 'api/project/' + params.id + '/config?id=' + params.id + '&model=project&action=cfg',
	// 	success	: callback,
	// })
}

function list(params,callback) {
	let url = 'project/list?page='+params.page+'&limit='+params.limit+'&order='+params.order;
	if(params.keyword) url += '&keyword=' + params.keyword;
	if(params.fid) url += '&fid=' + params.fid;
	url += '&folder=0';
	
	http.request({
		url		: url,
		success: (res) => {
			callback && callback(res);
		}
	})
}

function detail(params,callback) {
	http.request({
		url		: 'project/detail?id='+params,
		success: (res) => {
			callback && callback(res);
		}
	})
}

function create(params,callback) {
	http.request({
		url		: 'project/create',
		data	: params,
		success: (res) => {
			callback && callback(res);
		}
	})
}

function modify(params,callback) {
	http.request({
		url		: 'project/modify',
		data	: params,
		success: (res) => {
			callback && callback(res);
		}
	})
}

function remove(params,callback) {
	http.request({
		url		: 'project/remove',
		data	: params,
		success: (res) => {
			callback && callback(res);
		}
	})
}

function build(params,callback, error) {
	http.request({
		url		: 'project/build',
		data	: params,
		success: (res )=> {
			callback && callback(res);
		},
		error: res=>{
			error && error(res);
		}
	})
}

function pv(params,callback) {
	http.request({
		url		: 'project/pv?id=' + params.id,
		data	: params,
		success: (res) => {
			callback && callback(res);
		}
	})
}

function like(params,callback) {
	http.request({
		url		: 'project/like?id=' + params.id,
		data	: params,
		success: (res) => {
			callback && callback(res);
		}
	})
}
// function preview(params, callback){
// 	http.request({
// 		url		: 'project/preview?id=' + params.id,
// 		success: (res )=> {
// 			callback && callback(res);
// 		}
// 	})
// }

function save(params,callback) {
	http.request({
		url		: 'project/save',
		data	: params,
		success: (res )=> {
			callback && callback(res);
		}
	})
}

function publish(params,callback) {
	http.request({
		url		: 'project/publish',
		loading	: true,
		data	: params,
		success: (res )=> {
			callback && callback(res);
		}
	})
}

function share(params,callback) {
	http.request({
		url		: 'project/share?id='+params.id,
		// data	: params,
		success: (res )=> {
			callback && callback(res);
		}
	})
}

function setShare(params,callback) {
	http.request({
		url		: 'project/setshare',
		data	: params,
		success: (res )=> {
			callback && callback(res);
		}
	})
}
function type(params,callback) {
	http.request({
		url		: 'type/list',
		success: (res) => {
			callback && callback(res);
		}
	})
}
function tags(params,callback) {
	http.request({
		url		: 'project/tags',
		success: (res) => {
			callback && callback(res);
		}
	})
}

function move(params,callback) {
	http.request({
		url		: 'project/move',
		data	: params,
		success: (res) => {
			callback && callback(res);
		}
	})
}

function createPack(params,callback) {
	http.request({
		url		: 'pack/create',
		data	: params,
		success: (res) => {
			callback && callback(res);
		}
	})
}

function listPack(params,callback) {
	http.request({
		url		: 'pack/list',
		data	: params,
		success: (res) => {
			callback && callback(res);
		}
	})
}

function infoPack(params,callback) {
	http.request({
		url		: 'pack/info',
		data	: params,
		success: (res) => {
			callback && callback(res);
		}
	})
}

function downloadPack(params,callback) {
	http.request({
		url		: 'pack/download',
		data	: params,
		success: (res) => {
			callback && callback(res);
		}
	})
}

//加入社区
function open(params,callback) {
	http.request({
		url		: 'project/open',
		data	: params,
		success: (res) => {
			callback && callback(res);
		}
	})
}

//取消加入社区
function close(params,callback) {
	http.request({
		url		: 'project/close',
		data	: params,
		success: (res) => {
			callback && callback(res);
		}
	})
}

//精选作品
function selected(params,success,error) {
	http.request({
		url		: 'project/selected',
		data	: params,
		success,
		error,
	})
}
//精选作品
function selectedCheck(params,success,error) {
	http.request({
		url		: 'selected/check',
		data	: params,
		success,
		error,
	})
}

//复制作品
function copy(params,callback) {
	http.request({
		url		: 'project/duplicate',
		data	: params,
		success: (res) => {
			callback && callback(res);
		}
	})
}

//取消复制作品
function cancel_copy(params,callback) {
	http.request({
		url		: 'project/cancel_duplicate',
		data	: params,
		success: (res) => {
			callback && callback(res);
		}
	})
}


export default {
	info,
	list,
	remove,
	create,
	detail,
	build,
	// preview,
	save,
	modify,
	publish,
	share,
	setShare,
	type,
	tags,
	move,
	createPack,
	listPack,
	infoPack,
	downloadPack,
	open,
	close,
	selected,
	selectedCheck,
	copy,
	cancel_copy,
	pv,
	like
}